exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titlelable {\n  margin-top: 0px !important; }\n\n.titlesmall {\n  margin-top: 5px !important; }\n\na.navbar-brand {\n  color: #fafafa !important; }\n\n.lableh3 {\n  margin-top: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/layout/header/header.component.scss
// module id = ../../../../../src/app/layout/header/header.component.scss
// module chunks = main